import { MessageCardRenderer, MessageLabel } from '@/components';
import { useSendSeen } from '@/features/chats/viewmodels';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import './messageBubble.scss';

export const MessageBubble = React.memo(({ message, activeChatJid, isReady }) => {
   const bubbleRef = useRef(null);

   useSendSeen({ message, activeChatJid, isReady, elementRef: bubbleRef });

   const renderCard = () => {
      if (message.type === 'unread-separator') return <MessageLabel text={message.label} unreadSeparator />;
      if (message.type === 'date-label') return <MessageLabel text={message.label} />;

      return <MessageCardRenderer message={message} activeChatJid={activeChatJid} />;
   };

   return <div ref={bubbleRef}>{renderCard()}</div>;
});

MessageBubble.displayName = 'MessageBubble';

MessageBubble.propTypes = {
   message: PropTypes.shape({
      publisherId: PropTypes.string,
      msgType: PropTypes.string,
      msgId: PropTypes.string,
      messageId: PropTypes.string,
      fromUserId: PropTypes.string,
      type: PropTypes.string,
      label: PropTypes.string,
   }).isRequired,
   activeChatJid: PropTypes.string,
   isReady: PropTypes.bool,
};

export default MessageBubble;
